import { render, staticRenderFns } from "./EventPreviewModal.vue?vue&type=template&id=06853c71&lang=pug"
import script from "./EventPreviewModal.vue?vue&type=script&lang=ts"
export * from "./EventPreviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports